var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { BehaviorSubject } from "rxjs";
import { IdLang } from "./IdLang";
import { languageByCountryCode } from "./languageByCountryCode";
var UtilLoca = /** @class */ (function () {
    function UtilLoca() {
        var _this = this;
        this.langChange$ = new BehaviorSubject(IdLang.None);
        this.library = new Map();
        this.currentLang = IdLang.English;
        this.currentDictionary = {};
        this.options = {
            convertToSymbols: false,
            pipeCharacterSuffix: false,
        };
        this.languageLoaded = function (lang, dictionary) {
            _this.currentLang = lang;
            _this.library.set(lang, dictionary);
        };
        this.swapLang = function (lang) {
            _this.currentLang = lang;
            _this.currentDictionary = _this.library.get(_this.currentLang);
            _this.langChange$.next(lang);
        };
        this.get = function (id, replacements) {
            var result = _this.currentDictionary[id] || id;
            if (replacements) {
                result = Array.from(replacements.keys()).reduce(function (acc, key) {
                    while (replacements.get(key) !== key && acc.indexOf(key) >= 0) {
                        acc = acc.replace(key, replacements.get(key));
                    }
                    return acc;
                }, result);
            }
            if (_this.options.pipeCharacterSuffix) {
                result += "|";
            }
            if (_this.options.convertToSymbols) {
                return "•••";
            }
            return result;
        };
        this.getCurrentLanguage = function () {
            return _this.currentLang;
        };
        this.getLangFromCountryCode = function (code) {
            return languageByCountryCode.get(code) || IdLang.English;
        };
        this.getOptions = function () { return _this.options; };
        this.setOptions = function (options) {
            _this.options = __assign({}, _this.options, options);
            // To update all components using Loca
            _this.langChange$.next(_this.currentLang);
        };
    }
    return UtilLoca;
}());
export var utilLoca = new UtilLoca();



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/utilLoca.ts
// module id = 34
// module chunks = 3